import { Link } from "react-router-dom";

export default function PriceTableOne(){
    return(
        <>
            <section className="price-dropdown-area pt-120 pb-90 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30">
			<div className="container">
				<div className="row">
					<div className="col-lg-12 text-center mb-45">
						<div className="price-dropdown">
							<button className="price-btn">
								Monthly
							</button>
						</div>
					</div>
				</div>
				<div className="monthly-price">
					<div className="row">
						<div className="col-xl-3 col-lg-4 col-md-6">
							<div className="plan text-center mb-30">
								<div className="plan-header">
									<div className="icon">
										<img src="assets/img/price/ic-1.png" alt="Icon" />
									</div>
									<h6>Basic Plan</h6>
									<h2 className="price"><span>$</span>19<span className="text-body-color">/mo</span>
									</h2>

								</div>
								<ul className="plan-body">
									<li>Unlimited project</li>
									<li className="delet">Power And Predictive Dialing</li>
									<li className="delet">Quality & Customer Experience</li>
									<li className="delet">24/7 phone and email support</li>
								</ul>
								<div className="plan-footer mb-50">
									<Link className="border_btn" to="#">Get Trail 1 Month</Link>
								</div>
							</div>
						</div>
						<div className="col-xl-3 col-lg-4 col-md-6">
							<div className="plan text-center mb-30">
								<div className="plan-header">
									<div className="icon">
										<img src="assets/img/price/ic-2.png" alt="Icon" />
									</div>
									<h6>Advanced Plan</h6>
									<h2 className="price"><span>$</span>29<span className="text-body-color">/mo</span>
									</h2>

								</div>
								<ul className="plan-body">
									<li>Unlimited project</li>
									<li>Power And Predictive Dialing</li>
									<li className="delet">Quality & Customer Experience</li>
									<li className="delet">24/7 phone and email support</li>
								</ul>
								<div className="plan-footer mb-50">
									<Link className="border_btn" to="#">Get Trail 1 Month</Link>
								</div>
							</div>
						</div>
						<div className="col-xl-3 col-lg-4 col-md-6">
							<div className="plan text-center mb-30">
								<div className="plan-header">
									<div className="icon">
										<img src="assets/img/price/ic-3.png" alt="Icon" />
									</div>
									<h6>Team Plan</h6>
									<h2 className="price"><span>$</span>49<span className="text-body-color">/mo</span>
									</h2>

								</div>
								<ul className="plan-body">
									<li>Unlimited project</li>
									<li>Power And Predictive Dialing</li>
									<li>Quality & Customer Experience</li>
									<li className="delet">24/7 phone and email support</li>
								</ul>
								<div className="plan-footer mb-50">
									<Link className="border_btn" to="#">Get Trail 1 Month</Link>
								</div>
							</div>
						</div>
						<div className="col-xl-3 col-lg-4 col-md-6">
							<div className="plan text-center mb-30">
								<div className="plan-header">
									<div className="icon">
										<img src="assets/img/price/ic-4.png" alt="Icon" />
									</div>
									<h6>Business Plan</h6>
									<h2 className="price"><span>$</span>99<span className="text-body-color">/mo</span>
									</h2>
								</div>
								<ul className="plan-body">
									<li>Unlimited project</li>
									<li>Power And Predictive Dialing</li>
									<li>Quality & Customer Experience</li>
									<li>24/7 phone and email support</li>
								</ul>
								<div className="plan-footer mb-50">
									<a className="border_btn" href="#">Get Trail 1 Month</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="yearly-price">
					<div className="row">
						<div className="col-xl-3 col-lg-4 col-md-6">
							<div className="plan text-center mb-30">
								<div className="plan-header">
									<div className="icon">
										<img src="assets/img/price/ic-1.png" alt="Icon" />
									</div>
									<h6>Basic Plan</h6>
									<h2 className="price"><span>$</span>39<span className="text-body-color">/mo</span>
									</h2>

								</div>
								<ul className="plan-body">
									<li>Unlimited project</li>
									<li className="delet">Power And Predictive Dialing</li>
									<li className="delet">Quality & Customer Experience</li>
									<li className="delet">24/7 phone and email support</li>
								</ul>
								<div className="plan-footer mb-50">
									<a className="border_btn" href="#">Get Trail 1 Month</a>
								</div>
							</div>
						</div>
						<div className="col-xl-3 col-lg-4 col-md-6">
							<div className="plan text-center mb-30">
								<div className="plan-header">
									<div className="icon">
										<img src="assets/img/price/ic-2.png" alt="Icon" />
									</div>
									<h6>Advanced Plan</h6>
									<h2 className="price"><span>$</span>59<span className="text-body-color">/mo</span>
									</h2>

								</div>
								<ul className="plan-body">
									<li>Unlimited project</li>
									<li>Power And Predictive Dialing</li>
									<li className="delet">Quality & Customer Experience</li>
									<li className="delet">24/7 phone and email support</li>
								</ul>
								<div className="plan-footer mb-50">
									<a className="border_btn" href="#">Get Trail 1 Month</a>
								</div>
							</div>
						</div>
						<div className="col-xl-3 col-lg-4 col-md-6">
							<div className="plan text-center mb-30">
								<div className="plan-header">
									<div className="icon">
										<img src="assets/img/price/ic-3.png" alt="Icon" />
									</div>
									<h6>Team Plan</h6>
									<h2 className="price"><span>$</span>99<span className="text-body-color">/mo</span>
									</h2>
								</div>
								<ul className="plan-body">
									<li>Unlimited project</li>
									<li>Power And Predictive Dialing</li>
									<li>Quality & Customer Experience</li>
									<li className="delet">24/7 phone and email support</li>
								</ul>
								<div className="plan-footer mb-50">
									<a className="border_btn" href="#">Get Trail 1 Month</a>
								</div>
							</div>
						</div>
						<div className="col-xl-3 col-lg-4 col-md-6">
							<div className="plan text-center mb-30">
								<div className="plan-header">
									<div className="icon">
										<img src="assets/img/price/ic-4.png" alt="Icon" />
									</div>
									<h6>Business Plan</h6>
									<h2 className="price"><span>$</span>199<span className="text-body-color">/mo</span>
									</h2>

								</div>
								<ul className="plan-body">
									<li>Unlimited project</li>
									<li>Power And Predictive Dialing</li>
									<li>Quality & Customer Experience</li>
									<li>24/7 phone and email support</li>
								</ul>
								<div className="plan-footer mb-50">
									<a className="border_btn" href="#">Get Trail 1 Month</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}